import React, { useEffect, useState } from "react";
import { cambiarCuenta, crearCuentaPrincipal, listarCuentas } from "../../services/authService";

export default function SelectorCuenta() {
  const [cuentas, setCuentas] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [cambiando, setCambiando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    listarCuentas().then((x) => setCuentas(Array.isArray(x) ? x : [])).catch(() => setCuentas([]));
  }, []);

  const actual = cuentas.find((x) => x.actual);
  const tienePrincipal = cuentas.some((x) => x.tipo === "principal");

  if (cuentas.length === 0) return null;

  const guardarSesion = (data, perfilId) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("email", data.email || "");
    localStorage.setItem("rol", data.rol || "");
    localStorage.setItem("endpoint", data.endpoint || "");
    localStorage.setItem("esSuperAdmin", JSON.stringify(!!data.esSuperAdmin));
    localStorage.setItem("perfilId", String(data.perfilId || perfilId || ""));
    localStorage.setItem("tipoCuenta", data.tipoCuenta || "");
    window.dispatchEvent(new Event("auth-changed"));
    window.location.assign("/dashboard/admin?tab=Inicio");
  };

  const seleccionar = async (perfilId) => {
    if (perfilId === actual?.perfilId || cambiando) return;
    setCambiando(true);
    setError("");
    try {
      const data = await cambiarCuenta(perfilId);
      guardarSesion(data, perfilId);
    } catch (e) {
      setError(e?.response?.data?.mensaje || "No se pudo cambiar de cuenta.");
    } finally { setCambiando(false); }
  };

  const crearPrincipal = async () => {
    if (cambiando) return;
    setCambiando(true);
    setError("");
    try {
      const data = await crearCuentaPrincipal();
      guardarSesion(data, data.perfilId);
    } catch (e) {
      setError(e?.response?.data?.mensaje || "No se pudo crear la cuenta principal.");
      setCambiando(false);
    }
  };

  return <div className="relative min-w-0">
    <button type="button" onClick={() => setAbierto((v) => !v)}
      aria-expanded={abierto} title={actual?.nombreCuenta || "Cambiar cuenta"}
      className="account-selector-trigger border border-cyan-600/60 bg-cyan-950/40 hover:bg-cyan-900/50 text-cyan-100 px-3 py-2 rounded text-sm">
      <span className="truncate">{actual?.nombreCuenta || "Cambiar cuenta"}</span><span aria-hidden="true"> ▾</span>
    </button>
    {abierto && <div className="absolute left-0 mt-2 z-50 w-72 max-w-[calc(100vw-2rem)] rounded-lg border border-neutral-700 bg-neutral-900 shadow-xl p-2 break-words">
      <p className="px-2 py-1 text-xs text-neutral-400">Trabajar en otra cuenta</p>
      {cuentas.map((c) => <button key={c.perfilId} type="button" disabled={cambiando}
        onClick={() => seleccionar(c.perfilId)}
        className={`w-full text-left rounded p-2 mt-1 ${c.actual ? "bg-emerald-900/50 text-emerald-200" : "hover:bg-neutral-800 text-white"}`}>
        <span className="block text-sm font-medium">{c.nombreCuenta}</span>
        <span className="text-xs opacity-70">{c.tipo === "principal" ? "Principal" : "Temporal"} · {c.rol}</span>
      </button>)}
      {!tienePrincipal && <button type="button" disabled={cambiando} onClick={crearPrincipal}
        className="w-full text-left rounded border border-cyan-600/60 bg-cyan-950/40 hover:border-cyan-400 p-2 mt-2 text-white">
        <span className="block text-sm font-semibold text-cyan-300">Crear mi cuenta principal</span>
        <span className="text-xs opacity-70">Crear un ecosistema propio e independiente.</span>
      </button>}
      {error && <p className="px-2 pt-2 text-xs text-red-400">{error}</p>}
    </div>}
  </div>;
}
